<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="6"
                    md="5"
                    lg="3"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>
                        <v-container class="pb-0">
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success"
                                             transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit" auto>
                                        <v-text-field
                                                style="display: none;"
                                                ref="username"
                                                :label="$t('common.username') + '*'"
                                                name="userName"
                                                type="text"
                                                v-model="user.userName"

                                                :error-messages="usernameErrors"
                                                @input="$v.user.userName.$touch()"
                                                @blur="$v.user.userName.$touch()"
                                        ></v-text-field>
                                        <v-text-field
                                                autofocus
                                                id="password"
                                                :label="$t('common.password') + '*'"
                                                name="password"
                                                v-model="user.password"


                                                :type="showPassword ? 'text' : 'password'"
                                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                @click:append="showPassword = !showPassword"

                                                :error-messages="passwordErrors"
                                                @input="$v.user.password.$touch()"
                                                @blur="$v.user.password.$touch()"
                                        ></v-text-field>
                                     <v-checkbox v-model="user.rememberMe" :label="$t('common.rememberMe')" hide-details></v-checkbox>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-btn x-large color="success" class="login-button" :disabled="loading"
                                           @click="submit">{{ $t("common.continue") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                           <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <router-link
                                            class="caption"
                                            :to="{ name: 'requestPasswordReset' }">
                                        {{ $t("join.forgotPasswordLink") }}
                                    </router-link>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" style="padding: 0px 10px 10px 10px">
                                    <router-link
                                            class="caption"
                                            :to="{ name: 'login' }">
                                        {{ $t("common.back") }}
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {required, minLength, maxLength, email} from 'vuelidate/lib/validators'

    export default {
        name: 'LoginPassword',

        validations: {
            user: {
                password: {
                    required
                },
                userName: {
                    required
                }
            }
        },

        data: () => ({
            error: null,
            success: null,
            loading: false,

            context: '',

            user: {
                userName: '',
                password: '',
                rememberMe : true
            },
            showPassword: false,
        }),
        computed: {
            usernameErrors() {
                const errors = []

                if(!this.$v.user.userName.$dirty) {
                    return errors
                }

                !this.$v.user.userName.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            passwordErrors() {
                const errors = []

                if(!this.$v.user.password.$dirty) {
                    return errors
                }

                !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))

                return errors
            },
        },
        created() {
            if (!this.$route.params || !this.$route.params.username) {
                this.$router.push({name : 'login' });
            }

            this.user.userName = this.$route.params.username;

            this.$store.dispatch('isLoggedIn').then((responseData) => {
                if(responseData.success === true && responseData.result !== false && responseData.result.user) {
                    this.forwardToSharesuite();
                }
            });

            const email = this.$route.query.user;
            if(typeof email !== 'undefined') {
                this.user.userName = email;
            }
        },
        methods: {
            forwardToSharesuite() {
                const currentHash = window.location.hash;
                const hashParts = currentHash.split('#');
                let host = location.protocol + "//" + location.hostname + (!location.hostname.endsWith("/") ? "/" : "");
                let forwardHash = '';

                if(hashParts.length > 2) {
                  forwardHash = '#' + hashParts[2];
                }

                location.replace(host + process.env.VUE_APP_WEB_APP_PATH + '?' + forwardHash);
            },
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.loading = true;
                    this.error = null;
                    this.success = null;

                    this.$store.dispatch('login', {
                        user: this.user
                    }).then((responseData) => {
                        if(responseData.success === true && responseData.result !== false && responseData.result.user) {
                            this.forwardToSharesuite();
                        } else {
                            this.error = this.$t('join.errors.loginFailed');
                        }
                    }).catch((response) => {
                      const errorId = response.data.result.errorId;
                      switch(response.data.result.appId) {
                          // system
                        case 0:
                          switch(errorId) {
                              // already logged in
                            case 11:
                              this.forwardToSharesuite();
                              break;
                            default:
                              this.error = this.$t('join.errors.loginFailed');
                              break;
                          }
                          break;
                          // core
                        case 1:
                          switch(errorId) {
                            case 7:
                              this.error = this.$t("login.failedUserLocked");
                              break;
                            case 13:
                              this.error = this.$t('join.errors.noContextAvailable');
                              break;
                            default:
                              this.error = this.$t('join.errors.loginFailed');
                              break;
                          }
                          break;
                        default:
                          this.error = this.$t('join.errors.loginFailed');
                          break;
                      }
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
